import { useTranslation } from "next-i18next";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import PAImage from "../images/PAImage";
import PAText, { FONT_SIZE } from "../typography/PAText/PAText";
import bnplCardStyles from "./bnpl-card.module.scss";
import styles from "./sezzle-card.module.scss";

function SezzleCard(props) {
  const { showImage = false, points_className = "", text_2_container_class = "" } = props;
  const { t } = useTranslation();

  return (
    <div>

      <div className={styles.sezzle_header}>
        {t("Split your payments into 4, at 0% interest")}
        <sup>2</sup>
      </div>

      <HideIf show={!showImage}>
        <PAImage
          src={getRelativeImagePath("/cms/pubicImages/images/SezzleGraphic.webp")}
          alt="25% today, 25% week 2, 25% week 4, 25% week 6"
          desktopHeight="calc(25 * var(--safari-root-font, 10px))"
          tabletHeight="calc(25 * var(--safari-root-font, 10px))"
          mobileHeight="calc(18 * var(--safari-root-font, 10px))"
          // className="p-t-30 p-b-20"
        />
      </HideIf>

      <div className={bnplCardStyles.points_container}>
        <div className={`${bnplCardStyles.points} ${points_className}`}>
          <i className="fa fa-check-circle" aria-hidden="true" />
          <PAText bold>
            {t("0% interest")}
            <sup>2</sup>
          </PAText>
        </div>
        <div className={`${bnplCardStyles.points} ${points_className}`}>
          <i className="fa fa-check-circle" aria-hidden="true" />
          <PAText bold>{t("Pay in 4 equal installments over 6 weeks")}</PAText>
        </div>
        <div className={`${bnplCardStyles.points} ${points_className}`}>
          <i className="fa fa-check-circle" aria-hidden="true" />
          <PAText bold>{t("No credit-score impact")}</PAText>
        </div>
      </div>

      <PAText fontSize={FONT_SIZE[4]} bold centerAlign className={bnplCardStyles.sub_text}>
        {t("Select Sezzle at checkout to apply")}
      </PAText>
      <div className={`${styles.text_2_container} ${text_2_container_class}`}>
        <PAText inlineBlock className="m-t-20" color="medium-grey" centerAlign>
          {t("sezzle_footer_line")}
        </PAText>
      </div>
    </div>
  );
}

export default SezzleCard;
